<template>
  <div class="black-back">
    <div v-if="pageloading" class="dexame-loading-mask">
      <van-loading size="24px" color="#fff" vertical>加载中...</van-loading>
    </div>

    <div class="score-head">
      <div class="score-logo">
        <div class="score-logo-box">
          <img src="../../../assets/images/score/logo2.png" alt="">
        </div>
      </div>
      <div class="score-title">{{ startRow.saiqu_name }} {{ startRow.title }}</div>
      <div class="score-title-child">{{ currentSubject.subject_name }}</div>
      <div class="score-title-child">{{ currentSubject.mingcheng }}</div>
      <div class="score-title-child dexame-caipan-line">
        <template v-if="caipan_index >= 1000">高级裁判</template>
        <template v-else>裁判</template>
        {{ caipan_index }}：{{ caipan.name || '' }}
      </div>
    </div>

    <div class="score-content dexame-video-wrap" v-if="caipan_index==1000">
      <video
        v-if="videoPlayUrl"
        width="100%"
        height="180px"
        :src="videoPlayUrl"
        controls
      />
      <van-notice-bar v-else style="width:100%" text="视频未上传"/>
    </div>

    <div class="score-content dexame-fields-wrap">
      <div class="dexame-total-bar">
        <span>总分：{{ scoreTotalDisplay }}</span>
        <span v-if="scoreFixIcon === 'add'" class="fix-up"><van-icon name="play" style="transform: rotate(-90deg);" color="#ff0000"/></span>
        <span v-else-if="scoreFixIcon === 'pen'" class="fix-down"><van-icon name="play" style="transform: rotate(90deg);" color="#0dac0d"/></span>
      </div>

      <div v-if="!scoreForm.subject_scoreFieldsMap || scoreForm.subject_scoreFieldsMap.length === 0" class="dexame-empty-fields">
        <van-empty v-if="formLoadDone" description="评分表暂未配置或加载失败"/>
      </div>
      <van-cell-group v-else title="评分项" class="dexame-cell-group">
        <div
          v-for="field in scoreForm.subject_scoreFieldsMap"
          :key="field.name"
          class="dexame-score-item"
        >
          <div class="dexame-field-name">{{ field.name }}</div>
          <div class="dexame-max-hint">最高 {{ fieldMax(field) }} 分</div>
          <div class="dexame-stepper-row">
            <van-stepper
              v-model="scoreForm[field.name]"
              :min="0"
              :max="fieldMax(field)"
              :step="0.5"
              :disabled="!canEditScores"
              class="dexame-stepper"
            />
          </div>
          <van-slider
            v-model="scoreForm[field.name]"
            :min="0"
            :max="fieldMax(field)"
            :step="0.5"
            bar-height="6px"
            :disabled="!canEditScores"
            active-color="#1989fa"
            class="dexame-field-slider"
          />
        </div>
      </van-cell-group>

      <div class="dexame-submit-wrap">
        <van-button
          type="info"
          block
          round
          :loading="saveLoading"
          :disabled="!canEditScores"
          @click="onSubmit"
        >
          提交评分（{{ scoreTotalDisplay }}）
        </van-button>
      </div>
    </div>

    <div class="savebtn">
      <van-button size="normal" round @click="goPre">上一队</van-button>
      <van-button size="normal" round @click="showList">全部队伍 {{ current_index + 1 }}/{{ list.length }}</van-button>
      <van-button size="normal" round @click="goNext">下一队</van-button>
    </div>

    <van-popup v-model="listShow" style="width:90%; height:80%;">
      <div class="dexame-list-popup-inner">
        <van-cell-group>
          <van-cell
            v-for="(item, iindex) in list"
            :key="item.id"
            center
            is-link
            :icon="iindex === current_index ? 'success' : ''"
            :label="item.mingcheng"
            @click="onSelect(item, iindex)"
          >
            <template slot="title">
              <div class="flex-align">
                <span
                  class="font-size3 bold"
                  :class="Number(item.score) > 0 ? 'ok' : ''"
                >{{ iindex + 1 }}# {{ item.subject_name }}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
.dexame-loading-mask {
  z-index: 1000;
  background: #000;
  opacity: 0.5;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 100px;
}

.black-back {
  background: rgb(0, 0, 0);
  min-height: 100vh;
  padding-bottom: 24px;
}

.dexame-caipan-line {
  font-size: 13px;
  opacity: 0.95;
}

.dexame-video-wrap {
  margin-top: -10px;
  padding: 0 0.1835rem;
}

.dexame-fields-wrap {
  padding: 0.1835rem;
}

.dexame-total-bar {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #1989fa;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dexame-empty-fields {
  background: #fff;
  border-radius: 8px;
  padding: 16px 0;
}

.dexame-cell-group {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

/* 不用 van-cell 左右分栏，整行纵向排布，避免步进器、满分文案被裁切 */
.dexame-score-item {
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.dexame-score-item:last-child {
  border-bottom: none;
}

.dexame-field-name {
  font-size: 15px;
  font-weight: 500;
  color: #323233;
  line-height: 1.45;
  word-break: break-word;
  margin-bottom: 6px;
}

.dexame-max-hint {
  display: block;
  font-size: 12px;
  color: #969799;
  line-height: 1.4;
  margin-bottom: 10px;
}

.dexame-stepper-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 14px;
  padding: 0 4px;
  box-sizing: border-box;
}

.dexame-field-slider {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0 2px;
  margin-top: 2px;
}

/* 步进器在窄屏下可略缩小输入框，避免溢出 */
.dexame-stepper >>> .van-stepper__input {
  width: 44px;
  min-width: 36px;
  font-size: 14px;
}

.dexame-stepper >>> .van-stepper__minus,
.dexame-stepper >>> .van-stepper__plus {
  width: 28px;
  height: 28px;
}

.dexame-submit-wrap {
  margin-top: 8px;
}

.dexame-list-popup-inner {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.flex-align {
  display: flex;
  align-items: center;
}

.font-size3 {
  font-size: 15px;
}

.bold {
  font-weight: 600;
}

.ok {
  color: rgb(2, 110, 2);
  font-weight: bold;
}

.savebtn {
  display: flex;
  justify-content: space-between;
  padding: 12px 0.1835rem 0;
}

@media (max-width: 768px) {
  .score-head {
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1.6rem;
    height: 1.6rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
    position: relative;
  }

  .score-logo {
    position: absolute;
    top: 0.15rem;
    left: 0.195rem;
  }

  .score-logo-box {
    padding: 2px;
    border-radius: 100%;
  }

  .score-logo-box img {
    min-width: 0.5rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    border: 1px solid #fff;
  }

  .score-title {
    font-size: 0.2rem;
    padding: 0.2rem 0;
  }

  .score-title-child {
    font-size: 0.18rem;
  }
}

@media screen and (min-width: 768px) {
  .score-head {
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1rem;
    height: 1rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
    position: relative;
  }

  .score-logo {
    position: absolute;
    top: 0.1rem;
    left: 0.195rem;
  }

  .score-logo-box img {
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.2rem;
    padding: 0.1rem 0;
  }

  .score-title-child {
    font-size: 0.15rem;
  }
}
</style>

<script>
import {
  Button,
  Cell,
  CellGroup,
  Dialog,
  Empty,
  Icon,
  Loading,
  NoticeBar,
  Popup,
  Slider,
  Stepper,
  Toast,
} from 'vant'

export default {
  name: 'DexameScore',
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Empty.name]: Empty,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [NoticeBar.name]: NoticeBar,
    [Popup.name]: Popup,
    [Slider.name]: Slider,
    [Stepper.name]: Stepper,
  },
  data() {
    return {
      pageloading: false,
      listShow: false,
      saveLoading: false,
      formLoadDone: false,
      startId: 0,
      startRow: {},
      list: [],
      current_index: 0,
      caipan_index: 0,
      caipan: {},
      scoreForm: {
        id: '',
        subject_scoreFieldsMap: [],
        subject_scoreFieldsRow: {},
      },
      pollTimer: null,
    }
  },
  computed: {
    currentSubject() {
      const row = this.list[this.current_index]
      return row || {}
    },
    videoPlayUrl() {
      const v = this.currentSubject && this.currentSubject.video
      if (!v) return ''
      if (typeof v === 'string') return v
      if (Array.isArray(v) && v.length && v[0] && v[0].url) return v[0].url
      return ''
    },
    canEditScores() {
      const st = this.currentSubject.status
      return st === undefined || st === null || Number(st) === 1
    },
    scoreTotalDisplay() {
      const map = this.scoreForm.subject_scoreFieldsMap || []
      let s = 0
      map.forEach((f) => {
        const v = parseFloat(this.scoreForm[f.name])
        if (!isNaN(v)) s += v
      })
      return Math.round(s * 10) / 10
    },
    scoreFixIcon() {
      const ci = this.caipan_index
      const sub = this.currentSubject || {}
      const k = 'score_fix_' + ci
      return sub[k] || ''
    },
  },
  mounted() {
    document.title = '考试打分'
    const q = this.$route.query || {}
    let sid = parseInt(q.start_id || localStorage.getItem('_exame_start_id') || 0, 10)
    this.startId = sid > 0 ? sid : 0
    if (!localStorage.getItem('_id_num') || this.startId <= 0) {
      Toast('请先完成场次裁判绑定')
      if (typeof rbLink === 'function') {
        rbLink({
          name: 'DexameLogin',
          query: { start_id: this.startId || undefined }
        })
      }
      return
    }
    this.refreshAll(true)
    const that = this
    this.pollTimer = setInterval(function () {
      // that.refreshTable(false)
    }, 5000)
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
    }
  },
  methods: {
    fieldMax(field) {
      const m = Number(field && field.max)
      return !isNaN(m) && m > 0 ? m : 10
    },
    caipanNum() {
      return localStorage.getItem('_id_num') || ''
    },
    apiPayload() {
      return {
        start_id: this.startId,
        subject: '',
        num: this.caipanNum(),
      }
    },
    refreshAll(showLoading) {
      this.refreshTable(showLoading).then(() => {
        this.loadScoreForm()
      })
    },
    refreshTable(showLoading) {
      const that = this
      if (showLoading) that.pageloading = true
      return new Promise((resolve) => {
        that.$api.post('/api/saiexame/scoreTableDetail', that.apiPayload(), (res) => {
          if (showLoading) that.pageloading = false
          const d = res.data || {}
          that.startRow = d.row || {}
          that.list = d.list || []
          that.caipan_index = d.caipan_index
          that.caipan = d.caipan || {}
          if (that.current_index >= that.list.length) {
            that.current_index = Math.max(0, that.list.length - 1)
          }
          resolve()
        }, (err) => {
          if (showLoading) that.pageloading = false
          Toast(err.msg || '加载失败')
          resolve()
        }, 2)
      })
    },
    loadScoreForm() {
      const sub = this.currentSubject
      if (!sub || !sub.id) {
        this.formLoadDone = true
        this.scoreForm = {
          id: '',
          subject_scoreFieldsMap: [],
          subject_scoreFieldsRow: {},
        }
        return
      }
      const that = this
      that.formLoadDone = false
      that.$api.post('/api/saiexame/scoreFormdata', {
        row_id: sub.id,
        num: that.caipanNum(),
      }, (res) => {
        that.formLoadDone = true
        const data = res.data || {}
        that.scoreForm = data
        const map = data.subject_scoreFieldsMap || []
        map.forEach((f) => {
          const name = f.name
          if (that.scoreForm[name] === undefined || that.scoreForm[name] === null) {
            that.$set(that.scoreForm, name, 0)
          }
        })
      }, (err) => {
        that.formLoadDone = true
        Toast(err.msg || '加载评分表失败')
        that.scoreForm = {
          id: sub.id,
          subject_scoreFieldsMap: [],
          subject_scoreFieldsRow: {},
        }
      }, 2)
    },
    showList() {
      this.listShow = true
    },
    goPre() {
      if (this.current_index <= 0) {
        Toast('已经是第一支队伍了')
        return
      }
      this.current_index--
      this.refreshAll(true)
    },
    goNext() {
      if (this.current_index >= this.list.length - 1) {
        Toast('已经是最后一支队伍了')
        return
      }
      this.current_index++
      this.refreshAll(true)
    },
    onSelect(item, index) {
      this.current_index = index
      this.listShow = false
      this.refreshAll(true)
    },
    onSubmit() {
      const that = this
      const map = that.scoreForm.subject_scoreFieldsMap || []
      if (!map.length) {
        Toast('没有可提交的评分项')
        return
      }
      for (let i = 0; i < map.length; i++) {
        const n = map[i].name
        const v = that.scoreForm[n]
        if (v === '' || v === undefined || v === null) {
          Toast('请填写「' + n + '」')
          return
        }
      }
      Dialog.confirm({
        title: '评分',
        message: '确认提交吗？',
      }).then(() => {
        that.saveLoading = true
        that.$api.post('/api/saiexame/scoreFieldsSave', {
          row: that.scoreForm,
          caipan_index: that.caipan_index,
          num: that.caipanNum(),
        }, (res) => {
          that.saveLoading = false
          Toast.success((res.data && res.data.msg) || res.msg || '保存成功')
          that.refreshAll(false)
        }, (err) => {
          that.saveLoading = false
          Toast(err.msg || '保存失败')
        }, 2)
      }).catch(() => {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// DexameScore.vue?67b43b52